import api from "../api/api";
import { V2_BASE_URL } from "../api/bases";
import { getPracticeId } from "../config/practice";

/*
 * Interpretation Review calls (v2 only, api/interp_review/routes.py), pinned to v2 like the billing and fax code
 * (`_gw: "v2-pinned"`: no v1 fallback, no v2 circuit breaker). The server checks the practice (9928 only), the
 * "Interpretation Review" privilege and, for admin calls, the admin user ids on every request. Reviewer
 * answers are always the signed-in user's own. Nothing here files anything to Athena or the chart.
 */
export const INTERP_PRIVILEGE = "Interpretation Review";
const V2 = { baseURL: V2_BASE_URL, _gw: "v2-pinned" };
const base = () => `/v1/${getPracticeId()}/interp-review`;
const enc = (v) => encodeURIComponent(String(v));

export const interpError = (e, fallback = "Something went wrong") =>
  e?.response?.data?.message || e?.message || fallback;
export const interpErrorBody = (e) => e?.response?.data || null;

export const getAccess = () => api.get(`${base()}/access`, V2);
export const getSummary = () => api.get(`${base()}/summary`, V2);

export const listCalibration = () => api.get(`${base()}/calibration`, V2);
export const getCalibration = (id) => api.get(`${base()}/calibration/${enc(id)}`, V2);
export const saveCalibration = (id, body) => api.put(`${base()}/calibration/${enc(id)}`, body, V2);

export const listEcho = () => api.get(`${base()}/echo`, V2);
export const getEcho = (id) => api.get(`${base()}/echo/${enc(id)}`, V2);
export const saveEcho = (id, body) => api.put(`${base()}/echo/${enc(id)}`, body, V2);

export const adminProgress = () => api.get(`${base()}/admin/progress`, V2);
export const adminUnblind = (userId) => api.get(`${base()}/admin/unblind/${enc(userId)}`, V2);
export const adminExport = (userId) =>
  api.get(`${base()}/admin/export${userId ? `?user_id=${enc(userId)}` : ""}`, V2);
